import axios from 'axios';

// state
const state = {
  dataSerial: [],
};
// action
const actions = {
  async getSerial({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/read_serial.php`, param);
      commit('setCounter', res.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  async resetserialnumber({ commit }, param) {
    try {
      const res = await axios.post(`${this.state.API_URL}/reset_serial.php`, param);
      return res.data;
    } catch (error) {
      console.error(error);
    }

  },

  async filterdata({commit},param){
    try {
      const res=await axios.post(`${this.state.API_URL}/readserial.php`,param)
    } catch (error) {
      console.error (error);
    }
  },
   
  
};
const mutations = {
  setCounter(state, data) {
    state.dataSerial = data;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  state,
};
